module.exports = __webpack_public_path__ + "static/media/verified.36388848.svg";